import {createStore} from 'vuex';

const store = createStore({
    state: {
        authenticated: false,
        token: null,
        isUserAuthenticated: false,
        user: null,
        customerId: "",
        orderId: "",
        senderId: "",
        userPhone: "",
        userEmail: "",
        accountBalance: "",
        carrier: "",
        riderEmail: "",
        deleteUserId: "",
        deleteRiderId: "",
        resetEmail:""
    },

    mutations: {
        setAuthentication(state, status) {
            state.authenticated = status
        },

        setToken(state, tokenPayload) {
            state.token = tokenPayload
            if(tokenPayload && state.token !== null) {
                state.isUserAuthenticated = true 
            } else {
                state.isUserAuthenticated = false
            }
        },

        customerId(state, payload) {
            state.userEmail = payload
        },

        userPhone(state, payload) {
            state.userPhone = payload
        },
        userEmail(state, payload) {
            state.userEmail = payload
        },
        riderEmail(state, payload) {
            state.riderEmail = payload
        },

        senderId(state, payload) {
            state.senderId = payload
        },
        orderId(state, payload) {
            state.orderId = payload
        },

        deleteUserId(state, payload) {
            state.deleteUserId = payload
        },
        deleteRiderId(state, payload) {
            state.deleteRiderId = payload
        },

        userDetails(state, userPayload) {
            state.userId = userPayload
        },
       

        userName(state) {
            state.userId.email
        },

        accountBalance(state, payload) {
            state.accountBalance = payload
        },

        carrier(state, payload) {
            state.carrier = payload;
        },

        resetEmail(state, payload) {
            state.resetEmail = payload;
        }
    },

    getters: {

    },

    actions: {
        setToken({commit}, tokenPayload) {
            commit('setToken', tokenPayload)
        },

        userDetails({commit}, userPayload) {
            commit('userDetails', userPayload)
        },

        customerId({commit}, payload) {
            commit('customerId', payload)
        },
        senderId({commit}, payload) {
            commit('senderId', payload)
        },
        deleteUserId({commit}, payload) {
            commit('deleteUserId', payload)
        },
        deleteRiderId({commit}, payload) {
            commit('deleteRiderId', payload)
        },
        orderId({commit}, payload) {
            commit('orderId', payload)
        },

        resetEmail({commit}, payload) {
            commit('resetEmail', payload)
        }

    },

    modules: {
        
    }
});

export default store;